export enum Tenant {
    WIR = 'wir',
    SLF = 'slf',
    SLM = 'slm',
    TI8M = 'ti8m',
    NO_TENANT = 'no-tenant-loaded',
    BSU = 'bsu',
    SBS = 'sbs',
    GRB = 'grb',
    BSD = 'bsd',
    BKT = 'bkt',
    AKS = 'aks',
    EEK = 'eek',
    SKS = 'sks',
    ABS = 'abs',
    LPZ = 'lpz',
    BLB = 'blb',
    ARB = 'arb',
}

export enum TenantCodes {
    WIR = '8391',
    TI8M = '1337',
    SLF = '8784',
    SLM = '6363',
    BSU = '6888',
    SBS = '6342',
    GRB = '6807',
    BSD = '8389',
    BKT = '8733',
    AKS = '8518',
    EEK = '8394',
    SKS = '6633',
    ABS = '8390',
    LPZ = '6830',
    BLB = '6313',
    ARB = '6920',
}
